(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rs-core"]) return;
  try {
    
document.addEventListener('click',event=>{const toggle=event.target.closest('[data-menu-toggle]');if(toggle){const nav=document.getElementById(toggle.getAttribute('aria-controls'));const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open)}});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('[data-menu-toggle]').forEach(toggle=>toggle.setAttribute('aria-expanded','false'));document.querySelectorAll('.nav').forEach(nav=>nav.classList.remove('is-open'))}});
document.addEventListener('change',event=>{if(event.target.matches('[data-option-selector]')){const form=event.target.closest('form');const values=[...form.querySelectorAll('[data-option-selector]')].map(input=>input.value);const url=new URL(form.action);url.searchParams.set('option_values',values.join(','));location.assign(url.toString())}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-email-signup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rs-email-signup')) {
  customElements.define('rs-email-signup', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('[data-signup-open]');
      this.result = this.querySelector('[data-signup-result]');
      this.storageKey = 'rubin-singer:email-signup';
      this.designMode = Boolean(window.Shopify?.designMode);
      if (this.result?.dataset.signupResult === 'success' && !this.designMode) {
        this.save('subscribed', true);
      }
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      if (this.launcher) this.launcher.hidden = false;
      this.launcher?.addEventListener('click', () => this.open(false), options);
      this.querySelector('[data-signup-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        clearTimeout(this.timer);
        if (!this.designMode) this.save('dismissedUntil', Date.now() + Number(this.dataset.repeatDays) * 86400000);
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.open(false);
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail?.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
      }, options);
      if (this.result) {
        this.open(false);
      } else if (!this.designMode && this.dataset.autoOpen === 'true' && !this.suppressed()) {
        this.timer = setTimeout(() => this.open(true), Number(this.dataset.delay) * 1000);
      }
    }
    read(name) {
      try { return JSON.parse(localStorage.getItem(this.storageKey + ':' + name)); } catch { return null; }
    }
    save(name, value) {
      try { localStorage.setItem(this.storageKey + ':' + name, JSON.stringify(value)); } catch { /* Browsing remains available when storage is blocked. */ }
    }
    suppressed() {
      return this.dataset.subscribed === 'true' || this.read('subscribed') === true || Number(this.read('dismissedUntil')) > Date.now();
    }
    open(automatic) {
      if (!this.isConnected || !this.dialog || this.dialog.open) return;
      if (document.querySelector('dialog[open]')) return;
      if (automatic && (this.suppressed() || document.visibilityState === 'hidden' || document.activeElement?.closest('input,textarea,select,form'))) return;
      clearTimeout(this.timer);
      this.dialog.showModal();
      (this.result || this.querySelector('input[type="email"]') || this.querySelector('[data-signup-close]'))?.focus();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abortController?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-press-page"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('rs-press-gallery')) {
  customElements.define('rs-press-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('.rs-press-gallery__viewport');
      this.slides = Array.from(this.querySelectorAll('[data-slide-id]'));
      if (!this.viewport || !this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('.rs-press-gallery__count');
      this.controls = this.querySelector('.rs-press-gallery__controls');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : this.viewport.scrollWidth);
        }
      }, options);
      this.viewport.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(), 160);
      }, { ...options, passive: true });
      this.addEventListener('load', () => this.update(), { ...options, capture: true });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const slide = this.slides.find(item => item.dataset.slideId === event.detail?.blockId);
        if (!slide) return;
        const left = slide.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + this.viewport.scrollLeft;
        this.goTo(left, true);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.viewport);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.scrollTimer);
      this.controller = null;
    }
    goTo(left, instant = false) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollTo({ left, behavior: instant || reduced ? 'instant' : 'smooth' });
    }
    move(direction) {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      if ((direction < 0 && this.viewport.scrollLeft <= 2) || (direction > 0 && this.viewport.scrollLeft >= max - 2)) return;
      const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
      this.goTo(this.viewport.scrollLeft + direction * (this.viewport.clientWidth + gap));
    }
    update() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      this.previous.setAttribute('aria-disabled', String(this.viewport.scrollLeft <= 2));
      this.next.setAttribute('aria-disabled', String(this.viewport.scrollLeft >= max - 2));
      this.controls.hidden = max <= 2;
      const view = this.viewport.getBoundingClientRect();
      const visible = this.slides.map((slide, index) => {
        const rect = slide.getBoundingClientRect();
        return { index, visible: Math.min(rect.right, view.right) - Math.max(rect.left, view.left) >= rect.width * 0.5 };
      }).filter(item => item.visible);
      if (!visible.length) return;
      const first = visible[0].index + 1;
      const last = visible[visible.length - 1].index + 1;
      this.counter.textContent = (first === last ? first : first + '–' + last) + ' / ' + this.slides.length;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
